import React, { useState } from "react";
import { resolveFlagSrc } from "../../utils/flag-assets";

interface CountryFlagMarkerProps {
  countryCode: string;
  onClick: () => void;
  onMouseOver: () => void;
  onMouseOut: () => void;
}

const CountryFlagMarker: React.FC<CountryFlagMarkerProps> = ({
  countryCode,
  onClick,
  onMouseOver,
  onMouseOut,
}) => {
  const [failed, setFailed] = useState(false);
  const flagSrc = resolveFlagSrc(countryCode);

  if (!flagSrc || failed) {
    return null;
  }

  return (
    <img
      src={flagSrc}
      alt={`${countryCode} flag`}
      onClick={onClick}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      onError={() => setFailed(true)}
      style={{
        width: "2em",
        height: "2em",
        borderRadius: "50%",
        border: "2px solid #ffffff70",
        objectFit: "cover",
        cursor: "pointer",
        pointerEvents: "auto",
      }}
    />
  );
};

export default CountryFlagMarker;
